import type { ProviderProfile } from '@/lib/supabase'
import type { ProviderProfilePayload } from '@/types/forms'
import { callBridge } from './apiBridge'

export async function getMyProviderProfile(): Promise<ProviderProfile | null> {
  try {
    const result = await callBridge('get_provider_profile')
    return result
  } catch (error) {
    console.error(error)
    return null
  }
}

export async function createProviderProfileFromEnabler(payload: ProviderProfilePayload, organizationId?: string): Promise<{ success: boolean; id?: string; error?: string }>{
  try {
    const bridgePayload = organizationId ? { ...payload, organizationId } : payload
    const result = await callBridge('create_provider_profile', bridgePayload)
    return { success: true, id: result.id }
  } catch (error: any) {
    return { success: false, error: error?.message || 'Failed to create provider profile' }
  }
}
